// ==========================
// Version 1 - limits.js (reserve write slot)
// ==========================
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';

/**
 * Reserve a write slot for the current user.
 * Must be called immediately before creating a memory.
 * On success, you have ~5 seconds to perform the Firestore "memories" create.
 *
 * Throws FirebaseError('permission-denied') if the user is posting too fast.
 */
export async function reserveWriteSlot(uid) {
  const ref = doc(db, 'limits', uid);
  await setDoc(ref, { lastWriteAt: serverTimestamp() });
}
// ==========================
// Version 1 - limits.js
// ==========================